<template>
  <div fluid>
    <v-card class="card-wrap" :height="height">
      <v-card-title v-if="title">{{ $t('applog.message.title') }}</v-card-title>
      <div class="box">
        <v-row class="h-100">
          <v-col cols="12">
            <v-data-table :headers="headers" :items="msgs" item-key="key" :options.sync="options" :items-per-page="paging.rowsPerPage" :loading="loading" :height="forceHeight" class="elevation-1 content" must-sort fixed-header dense hide-default-footer>
              <template v-slot:item.msgtyIcon="{ item }">
                <v-tooltip content-class="tooltip" bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" :style="item.msgtyIcon.style" small>{{ item.msgtyIcon.icon }}</v-icon>
                  </template>
                  <span class="tooltip">{{ $t(`${item.msgtyIcon.msgCode}`) }}</span>
                </v-tooltip>
              </template>
              <template v-slot:item.ltxtsIcon="{ item }">
                <v-icon v-if="item.ltxtsIcon" :style="getThemeColor()" small @click="ltxtsDetail(item)">mdi-help-circle</v-icon>
              </template>
              <template v-slot:item.detailsIcon="{ item }">
                <v-icon v-if="item.detailsIcon" :style="getThemeColor()" small @click="detailsDetail(item)">mdi-magnify</v-icon>
              </template>
              <template #footer>
                <pagination :paging.sync="paging" :length="length" :disabled="loading"></pagination>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </div>
    </v-card>
    <!-- Dialog to show ltxts detail -->
    <v-dialog v-model="showLtxtsDialog" persistent max-width="800px">
      <v-card :max-height="460">
        <v-card-title>
          <v-icon color="primary">mdi-information</v-icon>
          <span style="padding-left:10px">{{ $t('applog.ltxts.detail.title') }}</span>
        </v-card-title>
        <v-card-text>
          <div v-html="ltxtsCntt" class="scrollable-content"></div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showLtxtsDialog = !showLtxtsDialog">{{ this.$t('common.confirm') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Dialog to show details detail -->
    <v-dialog v-model="showDetailsDialog" persistent max-width="800px">
      <v-card :max-height="460">
        <v-card-title>
          <v-icon color="primary">mdi-information</v-icon>
          <span style="padding-left:10px">{{ $t('applog.details.detail.title') }}</span>
        </v-card-title>
        <v-card-text>
          <div v-html="detailsCntt" class="scrollable-content"></div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showDetailsDialog = !showDetailsDialog">{{ this.$t('common.confirm') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { api } from '@/api/common/instances';

export default {
  props: {
    title: {
      type: Boolean,
      default: true,
    },
    height: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      msgs: [],
      headers: [
        { value: 'msgtyIcon', text: this.$t('syslog.field.title.type'), sortable: false, align: 'center', width: '6%' },
        { value: 'msgtxts', text: this.$t('syslog.field.title.msg.text'), sortable: false },
        { value: 'ltxtsIcon', text: this.$t('syslog.field.title.long.text'), sortable: false, align: 'center', width: '6%' },
        { value: 'detailsIcon', text: this.$t('syslog.field.title.details'), sortable: false, align: 'center', width: '6%' },
      ],
      options: {},
      paging: { page: 1, rowsPerPage: 100 },
      length: 0,
      loading: false,
      showLtxtsDialog: false,
      showDetailsDialog: false,
      ltxtsCntt: '',
      detailsCntt: '',
    };
  },
  computed: {
    forceHeight() {
      return this.height - 104;
    },
  },
  methods: {
    getThemeColor() {
      return this.$vuetify.theme.isDark ? 'color:white;' : 'color:black;';
    },
    removeDetailMessage() {
      this.msgs = [];
      this.length = 0;
    },
    async getDetailMessage(item) {
      this.loading = true;
      // eslint-disable-next-line prettier/prettier
      const { data: { items, pagination }} = await api.get('/detailview/dumplog/applog-msg', {
        params: {
          svrYmdhms: item.svrYmdhms,
          sstmId: item.sstmId,
          mandt: item.mandant,
          lognumber: item.lognumber,
          page: this.paging.page,
          limit: this.paging.rowsPerPage,
        },
      });
      this.msgs = items;
      this.length = pagination.totalCount;
      this.loading = false;
    },
    ltxtsDetail(item) {
      this.ltxtsCntt = item.ltxts.replace(/\n/g, '<br />');
      this.showLtxtsDialog = true;
    },
    detailsDetail(item) {
      this.detailsCntt = `
        ${this.$t('applog.details.detail.sub.title')}<br />
        <br />
        ${this.$t('applog.details.detail.msg')}<br />
        <br />
        ${this.$t('applog.details.detail.param')} 1:<br />
        ${this.$t('applog.details.detail.param')} 2:<br />
        ${this.$t('applog.details.detail.param')} 3:<br />
        <br />
        ${this.$t('applog.details.detail.std')} 1:&emsp;${item.msgv1}<br />
        ${this.$t('applog.details.detail.std')} 2:&emsp;${item.msgv2}<br />
        ${this.$t('applog.details.detail.std')} 3:&emsp;${item.msgv3}<br />
        ${this.$t('applog.details.detail.std')} 4:&emsp;${item.msgv4}<br />
      `;
      this.showDetailsDialog = true;
    },
  },
};
</script>

<style scoped>
.card-inner-div {
  overflow: auto;
}
.label {
  text-align: right;
  padding-right: 15px;
}
.tooltip {
  font-size: 11px;
}
.scrollable-content {
  height: 340px;
  overflow: auto;
}
</style>
